import { Param } from '../Param';

export class SortBy {
	constructor({ value, id = "sortBy" } = {}) {
		this.id = id;
		this.value = value;
		this.type = "SortBy";
	}

	toParam() {
		return new Param({ id: this.id, value: this.value });
	}
}